import TaskDetail from "./TaskDetail";

export default TaskDetail;
